import type { EditControlProps } from '../../declare'
import { useMemo } from 'react'
import { InputNumber } from 'antd'
import { $consts } from 'src/plugins'

const TextInput = (props: EditControlProps) => {
  const handleChange = (value: number) => {
    props.onChange?.(value)
  }

  const precision = useMemo(() => {
    switch (props.config.CONTROL_TYPE) {
      // 数字输入框：两位小数精度
      case $consts['TABLE/CONTROL_TYPE_NUMBERINPUT_TWODOT']:
        return 2
      // 数字输入框：三位小数精度
      case $consts['TABLE/CONTROL_TYPE_NUMBERINPUT_THREEDOT']:
        return 3
      default:
        return undefined
    }
  }, [props.config.CONTROL_TYPE])

  const { __READONLY__ } = props.config
  return (
    <InputNumber
      disabled={__READONLY__}
      value={props.value}
      precision={precision}
      onChange={val => handleChange(val)}
    />
  )
}

export default TextInput